import type Url from "@core-ui/ApiServices/Types/Url";

const useUrlImage = (src: Url) => {
	return src.toString();
};

export default useUrlImage;
